module.exports = __webpack_public_path__ + "static/media/Paia_Agency_Logo2020.487798b6.jpg";